import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../Controllers/hooks";
import { RootState } from "../../../../../Controllers/Store";
import { useSelector } from "react-redux";
import './Css/SiteVisit.css';
import './Css/SiteVisit-responsive.css';

import { Ripple } from "primereact/ripple";
import { ProgressSpinner } from "primereact/progressspinner";
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import { Nullable } from "primereact/ts-helpers";
import { Toast } from "primereact/toast";
import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";

import NoDataCreated from "../../../../../Components/NoDataCreated";
import DatePicker from "../../../../../Components/DatePicker";
import { formatDate, formatTo12HourTime, parseStringToDate } from "../../../../../Utils/getDate";
import ErrorPage from "../../../../../Components/ErrorPage";
import { goToTop } from "../../../../../Components/goToTop";
import Textarea from "../../../../../Components/TextArea";
import AlertModal from "../../../../../Components/AlertModal";
import { getLoginUserRoleName, UserRoleName } from "../../../../../Utils/LoginUserRoleName";
import { hasPermission } from "../../../../../Controllers/Selectors/permissionsSelector";
import { checkText } from "../../../../../Utils/Validator";

import {
    SiteVisit as SiteVisitType,
    InspectionList,
    PostInspectionList,
    InspectionTimeList,
    ThisSiteVisitInspectionList,
} from "../../../../../Controllers/Types/SiteVisit/SiteVisitTypes";

import { getAllSiteVisitList, getAllInspectionsList, getAllInspectionTimeList } from "../../../../../Controllers/Thunks/SiteVisitThunks";

import {
    createSiteVisit,
    updateSiteVisit,
    deleteSiteVisit,
    acceptSiteVisit
} from "../../../../../Api/SiteVisit/SiteVisitApiServices";
import TableActionLoader from "../../../../../Components/TableActionLoader";

const SiteVisit: React.FC = () => {
    const today = new Date();
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState<boolean>(false);
    const [inviteLoading, setInviteLoading] = useState<boolean>(false);
    const [draftLoading, setDraftLoading] = useState<boolean>(false);
    const toast = useRef<Toast>(null);
    const dispatch = useAppDispatch();
    const calendarRef = useRef<Calendar>(null);

    const projectData = location.state?.data;
    const folderId = Number(projectData.folder_id);

    const siteVisitLoading: boolean = useAppSelector((state) => state?.siteVisitList?.siteVisitLoading);
    const siteVisitError: string | null = useAppSelector((state) => state?.siteVisitList?.siteVisitError);

    const inspectionListError: string | null = useAppSelector((state) => state?.siteVisitList?.inspectionListError);
    const inspectionTimeListError: string | null = useAppSelector((state) => state?.siteVisitList?.inspectionTimeListError);

    const [loginUserRoleName, setLoginUserRoleName] = useState<UserRoleName | ''>('');

    const [dataState, setDataState] = useState<'Add' | 'Edit'>('Add');
    const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
    const [initialDataLoading, setInitialDataLoading] = useState<boolean>(true);
    const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string>('');
    const [siteVisitUpdateHasChanges, setSiteVisitUpdateHasChanges] = useState<boolean>(false);

    const [siteVisitData, setSiteVisitData] = useState<SiteVisitType[]>([]);
    const [selectedSiteVisitData, setSelectedSiteVisitData] = useState<SiteVisitType | null>(null);
    const [lastSiteVisitData, setLastSiteVisitData] = useState<SiteVisitType | null>(null);

    const [inspectionTimeListData, setInspectionTimeListData] = useState<InspectionTimeList[]>([]);
    const [selectedInspectionTime, setSelectedInspectionTime] = useState<InspectionTimeList | null>(null);
    const [siteVisitStatusFilterState, setSiteVisitStatusFilterState] = useState<'All' | 'Draft' | 'Pending' | 'Accepted' | 'Incomplete' | 'Complete'>('All');

    /* For Architect Site vist request */
    const [showSiteVisitRequestModal, setShowSiteVisitRequestModal] = useState<boolean>(false);
    const [siteVisitRequestDate, setSiteVisitRequestDate] = useState<Nullable<Date>>(today);
    const [siteVisitRequestNote, setSiteVisitRequestNote] = useState<string>('');

    const [inspectionListData, setInspectionListData] = useState<InspectionList[]>([]);
    const [customInspectionList, setCustomInspectionList] = useState<InspectionList[]>([]);
    const [selectedDefaultInspectionList, setSelectedDefaultInspectionList] = useState<PostInspectionList[]>([]);
    const [selectedCustomInspectionList, setSelectedCustomInspectionList] = useState<PostInspectionList[]>([]);
    const [selectedInspectionList, setSelectedInspectionList] = useState<PostInspectionList[]>([]);

    const [showInspectionListModal, setShowInspectionListModal] = useState<boolean>(false);
    const [showAddCustomData, setShowAddCustomData] = useState<boolean>(false);
    const [customInspection, setCustomInspection] = useState<string>('');
    const [customInspectionError, setCustomInspectionError] = useState<string>('');

    /* Errors */
    const [siteInspectionForError, setSiteInspectionForError] = useState<string>('');
    const [siteVisitRequestDateError, setSiteVisitRequestDateError] = useState<string>('');
    const [siteVisitRequestNoteError, setSiteVisitRequestNoteError] = useState<string>('');

    /* For Building inspector Site visit response */
    const [siteVisitAcceptDate, setSiteVisitAcceptDate] = useState<Nullable<Date>>(today);
    const [showSiteVisitResponseModal, setShowSiteVisitResponseModal] = useState<boolean>(false);
    const [isChangeAcceptDate, setIsChangeAcceptDate] = useState<boolean>(false);

    /* Errors */
    const [siteVisitAcceptDateError, setSiteVisitAcceptDateError] = useState<string>('');

    /* PERMISION HANDLER */
    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) =>
            hasPermission(state, screen, permission)
        );
    };

    const hasPermissionAddSiteVisit = useCanEdit("Site Visit", "add_site_visit");
    const hasPermissionEditSiteVisit = useCanEdit("Site Visit", "edit_site_visit");
    const hasPermissionDeleteSiteVisit = useCanEdit("Site Visit", "delete_site_visit");
    /*  */

    // Get logged in user role name
    useEffect(() => {
        const fetchUserRole = async () => {
            const roleName = await getLoginUserRoleName();
            setLoginUserRoleName(roleName);
        };

        fetchUserRole();
    }, []);

    // Fetch data initially from state
    useEffect(() => {
        siteVisitDataGet();

        dispatch(getAllInspectionsList());
        dispatch(getAllInspectionTimeList());
    }, [location?.state]);

    const siteVisitDataGet = async () => {
        await dispatch(getAllSiteVisitList(folderId));
        setInitialDataLoading(false);
    }

    // get the data from state
    const siteVisitList: SiteVisitType[] = useAppSelector((state) => state?.siteVisitList?.siteVisitList);
    const inspectionList: InspectionList[] = useAppSelector((state) => state?.siteVisitList?.inspectionList);
    const inspectionTimeList: InspectionTimeList[] = useAppSelector((state) => state?.siteVisitList?.inspectionTimeList);

    useEffect(() => {
        // Set site visit data to the list
        if (siteVisitList && siteVisitList?.length > 0) {
            let filteredData: SiteVisitType[] = [];

            if (siteVisitStatusFilterState === 'All') {
                filteredData = siteVisitList;
            } else {
                filteredData = siteVisitList?.filter((data) => data.status === siteVisitStatusFilterState);
            }
            setSiteVisitData(filteredData);
            setLastSiteVisitData(siteVisitList[siteVisitList.length - 1]);
        } else {
            setSiteVisitData([]);
            setLastSiteVisitData(null);
        }

        // Set inspection data to the list
        if (inspectionList && inspectionList?.length > 0) {
            const activeList = inspectionList?.filter((list) => list?.status === 1);
            setInspectionListData(activeList);
        } else {
            setInspectionListData([]);
        }

        // Set inspection time data to the list
        if (inspectionTimeList && inspectionTimeList?.length > 0) {
            const activeList = inspectionTimeList?.filter((list) => list?.status === 1);
            setInspectionTimeListData(activeList);
            setSelectedInspectionTime(activeList[0]);
        } else {
            setInspectionTimeListData([]);
            setSelectedInspectionTime(null);
        }
    }, [siteVisitStatusFilterState, siteVisitList, inspectionList, inspectionTimeList]);


    /* *********************************** For Architect *********************************** */
    // Close site visit request modal
    const handleCloseSiteVisitRequestModal = () => {
        setShowSiteVisitRequestModal(false);
        handleResetSiteVisitRequestFields();
    }

    // Create site visit request
    const handleRequestSiteVisit = () => {
        setDataState('Add');
        setShowSiteVisitRequestModal(true);
    }

    // Clear error messages
    useEffect(() => {
        if (selectedInspectionList && selectedInspectionList?.length > 0) {
            setSiteInspectionForError('');
        }
    }, [selectedInspectionList]);

    useEffect(() => {
        checkText(formatDate(siteVisitRequestDate!), false, setSiteVisitRequestDateError);
    }, [siteVisitRequestDate]);

    useEffect(() => {
        checkText(siteVisitRequestNote, false, setSiteVisitRequestNoteError);
    }, [siteVisitRequestNote]);

    // Check credentials for create site visit
    function checkCredentialsSiteVisit(): boolean {
        let isInspectionSelected = false;

        if (selectedInspectionList && selectedInspectionList?.length > 0) {
            isInspectionSelected = true;
        } else {
            isInspectionSelected = false;
            setSiteInspectionForError('Please select the inspection')
        }

        const isValidRequestDate = checkText(formatDate(siteVisitRequestDate!), true, setSiteVisitRequestDateError);
        const isValidRequestNote = checkText(siteVisitRequestNote, false, setSiteVisitRequestNoteError);

        return isInspectionSelected && isValidRequestDate && isValidRequestNote;
    }

    // Get api error messages
    function getApiErrorSiteVisit(keyName: string, error: string): void {
        if (keyName === "inspection_list[]") {
            setSiteInspectionForError(error);
        }

        if (keyName === "date") {
            setSiteVisitRequestDateError(error);
        }

        if (keyName === "note") {
            setSiteVisitRequestNoteError(error);
        }
    }

    // Save site visit request action
    const handleCreateSiteVisitRequest = async (e: React.FormEvent, siteVisitCreateState: 'Draft' | 'Pending') => {
        e.preventDefault();

        if (checkCredentialsSiteVisit()) {
            if (siteVisitCreateState === 'Draft') {
                setDraftLoading(true);
            } else {
                setInviteLoading(true);
            }

            const folder_id: number = folderId;
            const status: 'Draft' | 'Pending' = siteVisitCreateState;
            const date: string = formatDate(siteVisitRequestDate!);
            const note: string = siteVisitRequestNote;
            const inspection_list: PostInspectionList[] = selectedInspectionList;

            const data = await createSiteVisit(
                folder_id,
                status,
                date,
                note,
                inspection_list
            );

            if (siteVisitCreateState === 'Draft') {
                setDraftLoading(false);
            } else {
                setInviteLoading(false);
            }

            if (data?.statusCode === 200) {
                siteVisitDataGet();
                handleCloseSiteVisitRequestModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `${siteVisitCreateState === 'Draft' ? 'The request was created as draft.' : 'The request was created and successfully sent to the building inspector.'}`,
                        life: 4000,
                    });
                }
            } else if (data?.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) =>
                    getApiErrorSiteVisit(key, value[0])
                );
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error creating request.',
                        life: 3000
                    });
                }
            }
        }
    }

    // Edit site visit request
    const handleEditSiteVisitRequest = (data: SiteVisitType) => {
        if (data && data !== null) {
            setDataState('Edit');
            setSelectedSiteVisitData(data);
            setShowSiteVisitRequestModal(true);

            const existingInspectionList: ThisSiteVisitInspectionList[] = data?.this_site_visit_inspection_list ?? [];

            const defaultInspectionList: PostInspectionList[] = existingInspectionList
                .filter(item => item.type === 'Default')
                .map(item => ({
                    type: 'Default',
                    id: item.site_visit_inspection?.id!,
                    inspection_name: item.site_visit_inspection?.inspection_name!,
                }));

            const customInspectionList: PostInspectionList[] = existingInspectionList
                .filter(item => item.type === 'Custom')
                .map(item => ({
                    type: 'Custom',
                    id: null,
                    inspection_name: item.inspection_name,
                }));

            const customList: InspectionList[] = existingInspectionList
                .filter(item => item.type === 'Custom')
                .map(item => ({
                    id: null,
                    inspection_name: item.inspection_name,
                    status: 1,
                    reference: [],
                }));

            setCustomInspectionList(customList);
            setSelectedDefaultInspectionList(defaultInspectionList);
            setSelectedCustomInspectionList(customInspectionList);
            setSelectedInspectionList([...defaultInspectionList, ...customInspectionList]);

            setSiteVisitRequestDate(data?.date ? parseStringToDate(data?.date) : null);
            setSiteVisitRequestNote(data?.note!);
        }
    }

    useEffect(() => {
        if (selectedSiteVisitData) {
            const mappedInspections = (selectedSiteVisitData.this_site_visit_inspection_list || []).map(
                (i) => ({
                    id: i.inspection_id,
                    type: i.type,
                    inspection_name: i.inspection_name
                })
            );

            const normalizedSelected = selectedInspectionList.map((i) => ({
                id: i.id,
                type: i.type,
                inspection_name: i.inspection_name
            }));

            const listsAreEqual =
                normalizedSelected.length === mappedInspections.length &&
                normalizedSelected.every((sel) =>
                    mappedInspections.some(
                        (m) =>
                            m.id === sel.id &&
                            m.type === sel.type &&
                            m.inspection_name === sel.inspection_name
                    )
                );

            if (!listsAreEqual) {
                setSiteVisitUpdateHasChanges(true);
            } else if (formatDate(siteVisitRequestDate!) !== selectedSiteVisitData?.date) {
                setSiteVisitUpdateHasChanges(true);
            } else if (siteVisitRequestNote !== null && siteVisitRequestNote !== selectedSiteVisitData?.note) {
                setSiteVisitUpdateHasChanges(true);
            } else {
                setSiteVisitUpdateHasChanges(false);
            }
        }
    }, [selectedSiteVisitData, siteVisitRequestDate, siteVisitRequestNote, selectedInspectionList]);

    // Update site visit request action
    const handleUpdateSiteVisitRequest = async (e: React.FormEvent, siteVisitUpdateState: 'Draft' | 'Pending') => {
        e.preventDefault();

        if (checkCredentialsSiteVisit()) {
            if (siteVisitUpdateState === 'Draft') {
                setDraftLoading(true);
            } else {
                setInviteLoading(true);
            }

            const site_visit_id: number = selectedSiteVisitData?.id!;
            const status: 'Draft' | 'Pending' = siteVisitUpdateState;
            const date: string = formatDate(siteVisitRequestDate!);
            const note: string = siteVisitRequestNote;
            const inspection_list: PostInspectionList[] = selectedInspectionList;

            const data = await updateSiteVisit(
                site_visit_id,
                status,
                date,
                note,
                inspection_list
            );

            if (siteVisitUpdateState === 'Draft') {
                setDraftLoading(false);
            } else {
                setInviteLoading(false);
            }

            if (data?.statusCode === 200) {
                siteVisitDataGet();
                handleCloseSiteVisitRequestModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `${siteVisitUpdateState === 'Draft' ? 'The request was updated as draft.' : 'The request was updated and successfully sent to the building inspector.'}`,
                        life: 4000,
                    });
                }
            } else if (data?.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) =>
                    getApiErrorSiteVisit(key, value[0])
                );
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error updating request.',
                        life: 3000
                    });
                }
            }
        }
    }

    // Delete site visit request
    const handleDeleteSiteVisitRequest = () => {
        if (selectedSiteVisitData) {
            confirmDialog({
                message: `Are you sure you want to delete this site visit ${selectedSiteVisitData?.site_visit_no} request?`,
                header: 'Confirmation',
                icon: 'bi bi-info-circle',
                defaultFocus: 'accept',
                acceptClassName: 'p-button-danger',
                accept: () => deleteSiteVisitRequest(selectedSiteVisitData?.id!),
                dismissableMask: true,
                resizable: false,
                draggable: false,
            });
        }
    }

    // Delete site visit request action
    const deleteSiteVisitRequest = async (siteVisitId: number) => {
        setDeleteLoading(true);
        const result = await deleteSiteVisit(siteVisitId);

        setDeleteLoading(false);
        if (result?.statusCode === 200) {
            siteVisitDataGet();
            handleCloseSiteVisitRequestModal();

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Site visit request deleted successfully.',
                    life: 3000
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'There was an error deleting the site visit request.',
                    life: 3000
                });
            }
        }
    }

    // Reset site visit request fields
    const handleResetSiteVisitRequestFields = () => {
        setSelectedDefaultInspectionList([]);
        setSelectedCustomInspectionList([]);
        setShowAddCustomData(false);

        setSelectedInspectionList([]);
        setSiteVisitRequestDate(today);
        setSiteVisitRequestNote('');

        setSelectedSiteVisitData(null);
    }

    // Site visit request modal header
    const siteVisitRequestModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState === 'Add' ? (
                    <React.Fragment>
                        Create site visit&nbsp;
                        {lastSiteVisitData !== null ? (lastSiteVisitData?.site_visit_no + 1) : 1}&nbsp;Request
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        Edit site visit&nbsp;
                        {selectedSiteVisitData !== null ? (selectedSiteVisitData?.site_visit_no) : ''}&nbsp;Request
                    </React.Fragment>
                )}
            </h5>

            {dataState === "Edit" && hasPermissionDeleteSiteVisit ? (
                <React.Fragment>
                    {deleteLoading ? (
                        <TableActionLoader className="is_modal_loader" />
                    ) : (
                        <button
                            type="button"
                            className="close_modal_btn p-ripple"
                            onClick={handleDeleteSiteVisitRequest}
                        >
                            <i className="bi bi-trash3"></i>
                            <Ripple />
                        </button>
                    )}
                </React.Fragment>
            ) : (
                <button
                    type="button"
                    className="close_modal_btn p-ripple"
                    onClick={handleCloseSiteVisitRequestModal}
                >
                    <i className="bi bi-x-circle"></i>
                    <Ripple />
                </button>
            )}
        </div>
    );

    // Site visit request modal footer
    const siteVisitRequestModalFooter = () => {
        const draftSiteVisits = siteVisitData?.filter(data => data?.status === 'Draft') || [];
        const pendingSiteVisits = siteVisitData?.filter(data => data?.status === 'Pending') || [];

        const isSelectedSiteVisitPending = selectedSiteVisitData?.status === 'Pending';
        const isSelectedSiteVisitFirstDraft =
            draftSiteVisits.length > 0 && draftSiteVisits[0]?.id === selectedSiteVisitData?.id;

        const renderButton = (
            label: string,
            onClick: (e: any) => void,
            loading: boolean,
            className: string
        ) => (
            <Button
                label={loading ? 'Processing' : label}
                onClick={onClick}
                loading={loading}
                className={className}
                disabled={dataState === 'Edit' && !siteVisitUpdateHasChanges}
            />
        );

        const renderDraftButton = (onClick: (e: any) => void) =>
            renderButton('Save as Draft', onClick, draftLoading, 'custom_btn primary_light');

        const renderInviteButton = (onClick: (e: any) => void, label = 'Invite') =>
            renderButton(label, onClick, inviteLoading, 'custom_btn primary');

        const renderUpdateDraftButton = () =>
            renderButton('Update as Draft', (e) => handleUpdateSiteVisitRequest(e, 'Draft'), draftLoading, 'custom_btn primary_light');

        const renderUpdateInviteButton = (label = 'Update & Invite') =>
            renderButton(label, (e) => handleUpdateSiteVisitRequest(e, 'Pending'), inviteLoading, 'custom_btn primary');

        return (
            <div className="custom_modal_footer">
                {dataState === 'Add' && (
                    <React.Fragment>
                        {lastSiteVisitData?.status === 'Draft' || lastSiteVisitData?.status === 'Pending' ? (
                            renderDraftButton((e) => handleCreateSiteVisitRequest(e, 'Draft'))
                        ) : (
                            <React.Fragment>
                                {renderDraftButton((e) => handleCreateSiteVisitRequest(e, 'Draft'))}
                                {renderInviteButton((e) => handleCreateSiteVisitRequest(e, 'Pending'))}
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}

                {dataState === 'Edit' && (
                    <React.Fragment>
                        {isSelectedSiteVisitPending ? (
                            <React.Fragment>
                                {renderUpdateDraftButton()}
                                {renderUpdateInviteButton('Update & Re-Invite')}
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                {isSelectedSiteVisitFirstDraft && pendingSiteVisits.length === 0 ? (
                                    <React.Fragment>
                                        {renderUpdateDraftButton()}
                                        {renderUpdateInviteButton()}
                                    </React.Fragment>
                                ) : (
                                    renderUpdateDraftButton()
                                )}
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
            </div>
        );
    };


    const handleCloseInspectionListModal = () => {
        setShowInspectionListModal(false);

        handleResetCustomInspectionFields();
        setShowAddCustomData(false);
    }

    const handleShowInspectionListModal = () => {
        setShowInspectionListModal(true);
    };

    const handleSetInspectionList = () => {
        const allSelected: PostInspectionList[] = [
            ...selectedDefaultInspectionList,
            ...selectedCustomInspectionList,
        ];

        setSelectedInspectionList(allSelected);

        handleCloseInspectionListModal();
    };

    const inspectionListModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Inspection for
                <small className="modal_sub_title">Select the stage of works</small>
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseInspectionListModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const inspectionListModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseInspectionListModal}
            />

            <Button
                label={`Add (${selectedDefaultInspectionList.length + selectedCustomInspectionList.length})`}
                onClick={handleSetInspectionList}
                loading={loading}
                className="custom_btn primary"
                disabled={(selectedDefaultInspectionList.length + selectedCustomInspectionList.length) === 0}
            />
        </div>
    );

    const handleSelectDefaultInspection = (checked: boolean, inspection: InspectionList) => {
        const postInspection: PostInspectionList = {
            type: 'Default',
            id: inspection.id,
            inspection_name: inspection.inspection_name,
        };

        if (checked) {
            setSelectedDefaultInspectionList(prev => [...prev, postInspection]);
        } else {
            setSelectedDefaultInspectionList(prev =>
                prev.filter(item => item.id !== inspection.id)
            );
        }
    };

    const handleSelectCustomInspection = (checked: boolean, inspection: InspectionList) => {
        const postInspection: PostInspectionList = {
            type: 'Custom',
            id: null,
            inspection_name: inspection.inspection_name,
        };

        if (checked) {
            setSelectedCustomInspectionList(prev => [...prev, postInspection]);
        } else {
            setSelectedCustomInspectionList(prev =>
                prev.filter(item => item.inspection_name !== inspection.inspection_name)
            );
        }
    };

    // Custom inspection
    const handleToggleAddCustomData = () => {
        setShowAddCustomData(!showAddCustomData);
        handleResetCustomInspectionFields();
    }

    useEffect(() => {
        if (customInspection) {
            setCustomInspectionError('');
        }
    }, [customInspection]);

    const handleCreateCustomInspection = () => {
        const trimmedName = customInspection.trim();

        if (!trimmedName) {
            setCustomInspectionError("Stage of work is required.");
            return;
        }

        const isDuplicate =
            customInspectionList.some(item => item.inspection_name.toLowerCase() === trimmedName.toLowerCase()) ||
            selectedCustomInspectionList.some(item => item.inspection_name.toLowerCase() === trimmedName.toLowerCase());

        if (isDuplicate) {
            setCustomInspectionError("Stage of work must be unique.");
            return;
        }

        const newCustom: InspectionList = {
            id: null,
            inspection_name: trimmedName,
            status: 1,
            reference: [],
        };

        setCustomInspectionList(prev => [...prev, newCustom]);

        setSelectedCustomInspectionList(prev => [
            ...prev,
            {
                type: 'Custom',
                id: null,
                inspection_name: trimmedName,
            }
        ]);

        handleResetCustomInspectionFields();
    };

    const handleResetCustomInspectionFields = () => {
        setCustomInspection('');
        setCustomInspectionError('');
    }
    /* ************************************************************************************* */


    /* ******************************* For Building inspector ****************************** */
    const handleCloseSiteVisitResponseModal = () => {
        setShowSiteVisitResponseModal(false);
        handleResetSiteVisitResponseFields();
    }

    const handleResponseSiteVisit = (data: SiteVisitType) => {
        setSelectedSiteVisitData(data);
        setShowSiteVisitResponseModal(true);
    }

    const handleSaveSiteVisitResponse = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        const site_visit_id: number = selectedSiteVisitData?.id!;
        const time_id: number = selectedInspectionTime?.id!;
        const date: string = formatDate(siteVisitAcceptDate!);

        const data = await acceptSiteVisit(
            site_visit_id,
            time_id,
            date
        )

        setLoading(false);

        if (data?.statusCode === 200) {
            siteVisitDataGet();
            handleCloseSiteVisitResponseModal();

            if (toast.current) {
                toast.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `The request for the site visit ${selectedSiteVisitData?.site_visit_no} was successfully accepted.`,
                    life: 4000,
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: `There was an error accepting the site visit ${selectedSiteVisitData?.site_visit_no} request.`,
                    life: 3000
                });
            }
        }
    }

    /* Modal header */
    const siteVisitResponseModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Response to site visit {selectedSiteVisitData?.site_visit_no}
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseSiteVisitResponseModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );
    /*  */

    /* Modal footer */
    const siteVisitResponseModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label={loading ? 'Processing' : 'Accept'}
                onClick={handleSaveSiteVisitResponse}
                loading={loading}
                className="custom_btn primary"
            />
        </div>
    );

    const handleToggleChangeAcceptDate = () => {
        const next = !isChangeAcceptDate;
        setIsChangeAcceptDate(next);
        if (!isChangeAcceptDate) {
            setTimeout(() => {
                calendarRef.current?.show();
            }, 0);
        }
    };

    const handleResetSiteVisitResponseFields = () => {
        setSiteVisitAcceptDate(today);
        setSelectedInspectionTime(inspectionTimeListData[0]);
    }
    /* ************************************************************************************* */


    /* ********************************* Site visit common ********************************* */
    const handleFilterSiteVisit = (status: 'All' | 'Draft' | 'Pending' | 'Accepted' | 'Incomplete' | 'Complete') => {
        setSiteVisitStatusFilterState(status);
    }

    const handleViewSiteVisit = (data: SiteVisitType) => {
        if (data) {
            const isSignedReport: boolean = data?.sign_report === 1;

            if (loginUserRoleName === 'architect') {
                if (isSignedReport === true) {
                    navigate(`detail`, { state: { projectData: projectData, siteVisitData: data } });
                } else {
                    setShowAlertModal(true);
                    setAlertMessage(`That report has not yet been signed by the building inspector.`)
                }
            } else if (loginUserRoleName === 'building inspector') {
                navigate(`detail`, { state: { projectData: projectData, siteVisitData: data } });
            }
        }
        goToTop();
    }

    const inspectionListBody = (rowData: SiteVisitType) => {
        const inspectionNames: string[] = rowData?.siteVisitInspectionList
            ?.filter(data => !!data?.inspection_name)
            ?.map(data => data.inspection_name) ?? [];

        const formattedNames =
            inspectionNames.length === 0
                ? ''
                : inspectionNames.length === 1
                    ? inspectionNames[0]
                    : inspectionNames.length === 2
                        ? inspectionNames.join(' and ')
                        : `${inspectionNames.slice(0, -1).join(', ')} and ${inspectionNames.slice(-1)}`;

        return (
            <span>
                {formattedNames}
            </span>
        )
    }

    const statusBody = (rowData: SiteVisitType) => {
        const status = rowData.status;
        let color = "";
        let bgColor = "";

        if (status === 'Accepted') {
            color = "#008cc3";
            bgColor = "#daf2fb";
        } else if (status === 'Pending') {
            color = "#de9725";
            bgColor = "#f8f0d6";
        } else if (status === 'Complete') {
            color = "#06b500";
            bgColor = "#d5f8df";
        } else if (status === 'Draft') {
            color = "#656565";
            bgColor = "#EEE";
        } else if (status === 'Incomplete') {
            color = "#f60000";
            bgColor = "#fee2e2";
        }

        return (
            <div className="flex_center">
                <span className="priority_label lg" style={{ color: color, backgroundColor: bgColor }}>
                    {status === 'Complete' ? 'Completed' : status}
                </span>
            </div>
        );
    };

    const tableActionBody = (rowData: SiteVisitType) => {
        const isSiteVisiInDraft: boolean = rowData?.status === 'Draft';
        const isSiteVisiInPending: boolean = rowData?.status === 'Pending';

        return (
            <React.Fragment>
                {loginUserRoleName === 'architect' ? (
                    <div className={`table_action_btn_area justify-content-end mt-1 mb-1`}>
                        <button
                            className="table_action_btn fixed_width p-ripple"
                            onClick={() => handleViewSiteVisit(rowData)}
                            disabled={isSiteVisiInDraft || isSiteVisiInPending}
                        >
                            View
                            <Ripple />
                        </button>

                        {hasPermissionEditSiteVisit && (
                            <button
                                className="table_action_btn fixed_width p-ripple"
                                onClick={() => handleEditSiteVisitRequest(rowData)}
                                disabled={!(isSiteVisiInDraft || isSiteVisiInPending)}
                            >
                                Edit
                                <Ripple />
                            </button>
                        )}
                    </div>
                ) : loginUserRoleName === 'building inspector' ? (
                    <div className={`table_action_btn_area justify-content-end mt-1 mb-1`}>
                        <button
                            className="table_action_btn fixed_width p-ripple"
                            onClick={() => handleViewSiteVisit(rowData)}
                            disabled={isSiteVisiInPending}
                        >
                            View
                            <Ripple />
                        </button>

                        <button
                            className="table_action_btn fixed_width p-ripple"
                            onClick={() => handleResponseSiteVisit(rowData)}
                            disabled={!isSiteVisiInPending}
                        >
                            Response
                            <Ripple />
                        </button>
                    </div>
                ) : null}
            </React.Fragment>
        )
    }
    /* ************************************************************************************* */


    /* ********************************* Common functions ********************************** */
    const goBack = () => {
        navigate(-1);
        goToTop();
    };
    /* ************************************************************************************* */

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content full_screen_view">
                {siteVisitLoading && initialDataLoading ? (
                    <div className="loading_container">
                        <ProgressSpinner className="progresscircle custom" style={{ width: '50px', height: '50px', stroke: '#8953D7' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration="1s" />
                    </div>
                ) : siteVisitError ? (
                    <ErrorPage errorMessage={siteVisitError} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="page_breadcrumb_area">
                            <ul className="page_breadcrumb">
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                    {projectData.job_number} : {projectData.address}
                                </li>

                                <li className="page_breadcrumb_item has_child">
                                    {projectData.folder}
                                </li>

                                <li className="page_breadcrumb_item active">
                                    {projectData.feature_name}
                                </li>
                            </ul>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_header_area mt-sm-3 mt-3">
                            <div className="contact_tabs">
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn fixed_min_width 
                                            ${siteVisitStatusFilterState === "All" ? "active" : ""} p-ripple`}
                                        onClick={() => handleFilterSiteVisit('All')}
                                    >
                                        All : {String(siteVisitList?.length).padStart(2, '0')}
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>

                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn fixed_min_width 
                                            ${siteVisitStatusFilterState === "Draft" ? "active" : ""} p-ripple`}
                                        onClick={() => handleFilterSiteVisit("Draft")}
                                    >
                                        Draft : {String(siteVisitList?.filter(data => data?.status === 'Draft')?.length).padStart(2, '0')}
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>

                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn fixed_min_width 
                                            ${siteVisitStatusFilterState === "Pending" ? "active" : ""} p-ripple`}
                                        onClick={() => handleFilterSiteVisit("Pending")}
                                    >
                                        Pending : {String(siteVisitList?.filter(data => data?.status === 'Pending')?.length).padStart(2, '0')}
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>

                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn fixed_min_width 
                                            ${siteVisitStatusFilterState === "Accepted" ? "active" : ""} p-ripple`}
                                        onClick={() => handleFilterSiteVisit("Accepted")}
                                    >
                                        Accepted : {String(siteVisitList?.filter(data => data?.status === 'Accepted')?.length).padStart(2, '0')}
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>

                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn fixed_min_width 
                                            ${siteVisitStatusFilterState === "Incomplete" ? "active" : ""} p-ripple`}
                                        onClick={() => handleFilterSiteVisit("Incomplete")}
                                    >
                                        Incomplete : {String(siteVisitList?.filter(data => data?.status === 'Incomplete')?.length).padStart(2, '0')}
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>

                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn fixed_min_width 
                                            ${siteVisitStatusFilterState === "Complete" ? "active" : ""} p-ripple`}
                                        onClick={() => handleFilterSiteVisit("Complete")}
                                    >
                                        Completed : {String(siteVisitList?.filter(data => data?.status === 'Complete')?.length).padStart(2, '0')}
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                            </div>

                            {loginUserRoleName === 'architect' && hasPermissionAddSiteVisit && (
                                <div className="page_action_area">
                                    <button
                                        className="add_data_link_btn p-ripple"
                                        onClick={handleRequestSiteVisit}>
                                        <i className="bi bi-plus-circle"></i>
                                        <span>Request site visit</span>
                                        <Ripple />
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className="page_main_content_section no_header">
                            {siteVisitData && siteVisitData?.length > 0 ? (
                                <DataTable
                                    value={siteVisitData}
                                    paginator
                                    rows={10}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    paginatorDropdownAppendTo={'self'}
                                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                    size="small"
                                    tableStyle={{ minWidth: "50rem" }}
                                    className="page_table p-0 p-sm-2"
                                    rowHover
                                    scrollable
                                    loading={siteVisitLoading}
                                >
                                    <Column
                                        header="Site visit"
                                        headerClassName="text_purple"
                                        body={(rowData: SiteVisitType) => (
                                            <span className="text_bold text_no_wrap">
                                                {rowData.site_visit_no ? ('Site visit ' + rowData.site_visit_no) : "---"}
                                            </span>
                                        )}
                                        style={{ width: "10%" }}
                                    ></Column>

                                    <Column
                                        header="Inspection for"
                                        headerClassName="text_purple"
                                        body={inspectionListBody}
                                        style={{ width: "25%" }}
                                    ></Column>

                                    {siteVisitStatusFilterState === 'All' && (
                                        <Column
                                            header="Status"
                                            alignHeader={"center"}
                                            headerClassName="text_purple"
                                            body={statusBody}
                                            style={{ width: "12%" }}
                                        ></Column>
                                    )}

                                    <Column
                                        header="Request Date"
                                        headerClassName="text_purple "
                                        body={(rowData: SiteVisitType) => (
                                            <span className="text_no_wrap">
                                                {rowData.date ? rowData.date : "---"}
                                            </span>
                                        )}
                                        style={{ width: "13%" }}
                                    ></Column>

                                    <Column
                                        header="Inspection date & time"
                                        headerClassName="text_purple"
                                        body={(rowData: SiteVisitType) => (
                                            rowData.time_id && rowData?.bi_date ? (
                                                <React.Fragment>
                                                    <span className="text_no_wrap">
                                                        {rowData.bi_date}&nbsp;&nbsp;|&nbsp;&nbsp;
                                                    </span>

                                                    <span className="text-secondary text_no_wrap">
                                                        {formatTo12HourTime(rowData?.start_time)}
                                                        &nbsp;&nbsp;-&nbsp;&nbsp;
                                                        {formatTo12HourTime(rowData?.end_time)}
                                                    </span>
                                                </React.Fragment>
                                            ) : (
                                                <span className="text-secondary">
                                                    ----
                                                </span>
                                            )
                                        )}
                                        style={{ width: "25%" }}
                                    ></Column>

                                    <Column
                                        body={tableActionBody}
                                        className="table_btn_area"
                                        style={{ width: "15%" }}
                                        frozen={window.innerWidth > 575}
                                        alignFrozen="right"
                                    ></Column>
                                </DataTable>
                            ) : (
                                <NoDataCreated message={`No ${siteVisitStatusFilterState === 'All' ? '' : siteVisitStatusFilterState} site visit data found. ${hasPermissionAddSiteVisit && loginUserRoleName === 'architect' ? 'Click the Request button to create a site visit request.' : ''}`} />
                            )}
                        </div>
                    </div>
                )}
            </div>


            {/* Site vist request modal */}
            <Dialog
                visible={showSiteVisitRequestModal}
                header={siteVisitRequestModalHeader}
                footer={siteVisitRequestModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseSiteVisitRequestModal}
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {/* Inspection for */}
                            <div className="col-12">
                                <div className="page_form_group">
                                    <label htmlFor='inspectionFor' className={`custom_form_label is_required`}>Inspection for</label>
                                    <div className="data_chips_input">
                                        <div className="data_chips_container" onClick={handleShowInspectionListModal}>
                                            {selectedInspectionList && selectedInspectionList?.length > 0 ? (
                                                <React.Fragment>
                                                    {selectedInspectionList?.map((inspectionList, index) => {
                                                        return (
                                                            <span className="data_chip_label" key={index}>
                                                                {inspectionList?.inspection_name}
                                                            </span>
                                                        )
                                                    })}
                                                </React.Fragment>
                                            ) : (
                                                <span className="placeholder_text">Click the add button to select stage of works</span>
                                            )}
                                        </div>
                                        <button
                                            className="add_value_btn p-ripple"
                                            onClick={handleShowInspectionListModal}
                                        >
                                            {selectedInspectionList && selectedInspectionList?.length === 0 ? (
                                                <React.Fragment>
                                                    <i className="bi bi-plus-lg"></i>
                                                    <span>Add</span>
                                                </React.Fragment>
                                            ) : (
                                                <React.Fragment>
                                                    <i className="bi bi-pencil-square"></i>
                                                    <span>Change</span>
                                                </React.Fragment>
                                            )}
                                            <Ripple />
                                        </button>

                                    </div>

                                    {siteInspectionForError &&
                                        <small className="form_error_msg">{siteInspectionForError}</small>
                                    }
                                </div>
                            </div>

                            {/* Date */}
                            <div className="col-12">
                                <DatePicker
                                    key={`siteVisitRequestDate`}
                                    id="siteVisitRequestDate"
                                    label="Date"
                                    labelHtmlFor="siteVisitRequestDate"
                                    required={true}
                                    value={siteVisitRequestDate}
                                    minDate={today}
                                    placeholder="dd/mm/yyyy"
                                    onChange={setSiteVisitRequestDate}
                                    error={siteVisitRequestDateError}
                                    showClear
                                    onClear={() => setSiteVisitRequestDate(null)}
                                />
                            </div>

                            {/* Note */}
                            <div className="col-12">
                                <Textarea
                                    key={`siteVisitRequestNote`}
                                    id="siteVisitRequestNote"
                                    label="Note"
                                    labelHtmlFor="siteVisitRequestNote"
                                    required={false}
                                    value={siteVisitRequestNote}
                                    placeholder="Note"
                                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setSiteVisitRequestNote(e.target.value)}
                                    error={siteVisitRequestNoteError}
                                    formGroupClassName="mb-3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Inspection list modal */}
            <Dialog
                visible={showInspectionListModal}
                header={inspectionListModalHeader}
                footer={inspectionListModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_xsm"
                onHide={handleCloseInspectionListModal}
                contentClassName="pb-0"
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="px-2 py-1 w-100">
                        <div className="row">
                            <div className="col-12 mb-4">
                                <div className="inspection_list_area">
                                    <h6 className="inspection_list_head">
                                        Default stage of works
                                    </h6>

                                    {inspectionListError ? (
                                        <div className="empty_inspection_area">
                                            <p><i className="bi bi-exclamation-circle me-1"></i>
                                                There was an error retrieving the default stage of works!
                                            </p>
                                        </div>
                                    ) : (
                                        <React.Fragment>
                                            {inspectionListData && inspectionListData?.length > 0 ? (
                                                <ul className="inspection_list_container">
                                                    {inspectionListData?.map((inspection) => {
                                                        const isSelected = selectedDefaultInspectionList.some(item => item.id === inspection.id);

                                                        return (
                                                            <li className="inspection_list_item" key={inspection?.id}>
                                                                <Checkbox
                                                                    inputId={`inspection_${inspection?.id}`}
                                                                    checked={isSelected}
                                                                    onChange={(e: CheckboxChangeEvent) => handleSelectDefaultInspection(e.checked!, inspection)}
                                                                />
                                                                <label htmlFor={`inspection_${inspection?.id}`}
                                                                    className={`inspection_list_label ${isSelected ? 'selected' : ''}`}>
                                                                    {inspection?.inspection_name}
                                                                </label>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            ) : (
                                                <div className="empty_inspection_area">
                                                    <p><i className="bi bi-exclamation-circle me-1"></i>
                                                        There are no default stage of works!
                                                    </p>
                                                </div>
                                            )}
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>

                            <div className="col-12 mb-4">
                                <div className="inspection_list_area">
                                    <h6 className="inspection_list_head">
                                        Custom stage of works
                                    </h6>

                                    {customInspectionList && customInspectionList?.length > 0 && (
                                        <ul className="inspection_list_container">
                                            {customInspectionList?.map((customInspection, index) => {
                                                const isSelected = selectedCustomInspectionList.some(
                                                    item => item.inspection_name === customInspection.inspection_name
                                                );

                                                return (
                                                    <li className="inspection_list_item" key={index}>
                                                        <Checkbox
                                                            inputId={`custom_inspection_${index}`}
                                                            onChange={(e: CheckboxChangeEvent) => handleSelectCustomInspection(e.checked!, customInspection)}
                                                            checked={isSelected}
                                                        />
                                                        <label htmlFor={`custom_inspection_${index}`}
                                                            className={`inspection_list_label ${isSelected ? 'selected' : ''}`}>
                                                            {customInspection?.inspection_name}
                                                        </label>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="add_list_btn_area justify-content-end align-items-end flex-column gap-0 px-2">
                        <button className={`add_data_btn ${showAddCustomData ? 'danger' : ''} p-ripple`} onClick={handleToggleAddCustomData}>
                            <i className={`bi ${showAddCustomData ? 'bi-dash-circle' : 'bi-plus-circle'}`}></i>
                            {showAddCustomData ? 'Cancel' : 'Add custom'}
                            <Ripple />
                        </button>

                        <div className="add_data_input_container w-100">
                            <div className={`add_data_input_area ${showAddCustomData ? 'show mt-2' : ''}`}>
                                <InputText
                                    id="customInspection"
                                    value={customInspection}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomInspection(e.target.value)}
                                    className="custom_form_input"
                                    placeholder="Enter stage of work"
                                />

                                <Button
                                    label="Add"
                                    disabled={customInspection === ''}
                                    className="add_custom_btn"
                                    onClick={handleCreateCustomInspection}
                                />
                            </div>
                            {customInspectionError &&
                                <small className="form_error_msg">{customInspectionError}</small>
                            }
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Site vist response modal */}
            <Dialog
                visible={showSiteVisitResponseModal}
                header={siteVisitResponseModalHeader}
                footer={siteVisitResponseModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseSiteVisitResponseModal}
                dismissableMask>
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-4 pt-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            {selectedSiteVisitData && selectedSiteVisitData != null && (
                                <div className="col-12">
                                    <div className="data_display_area">
                                        <div className="data_display_grp">
                                            <h6>Inspection for: </h6>
                                            <p>
                                                {inspectionListBody(selectedSiteVisitData)}
                                            </p>
                                        </div>

                                        <div className="data_display_grp">
                                            <h6 className="data_display_label">Note: </h6>
                                            <p>{selectedSiteVisitData?.note ? selectedSiteVisitData?.note : '----'}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Date */}
                            <div className="col-12">
                                <div className="accept_date_container">
                                    <DatePicker
                                        ref={calendarRef}
                                        key={`siteVisitAcceptDate`}
                                        id="siteVisitAcceptDate"
                                        label="Date"
                                        labelHtmlFor="siteVisitAcceptDate"
                                        required={false}
                                        value={siteVisitAcceptDate}
                                        minDate={today}
                                        placeholder="dd/mm/yyyy"
                                        onChange={setSiteVisitAcceptDate}
                                        error={siteVisitAcceptDateError}
                                        inputDisabled={!isChangeAcceptDate}
                                    />

                                    <button className={`is_btn date_change_btn ${isChangeAcceptDate ? 'danger' : 'primary'}`}
                                        onClick={handleToggleChangeAcceptDate}>
                                        {isChangeAcceptDate ? 'Cancel' : 'Change'}
                                    </button>
                                </div>
                            </div>

                            {/* Visit time */}
                            <div className="col-12">
                                {inspectionTimeListError ? (
                                    <div className="empty_inspection_area">
                                        <p><i className="bi bi-exclamation-circle me-1"></i>
                                            There was an error retrieving inspection time data!
                                        </p>
                                    </div>
                                ) : (
                                    <React.Fragment>
                                        {inspectionTimeListData && inspectionTimeListData?.length > 0 && (
                                            <div className="visit_time_area">
                                                {inspectionTimeListData?.map((time) => (
                                                    <div className="visit_time_container" key={time?.id}>
                                                        <div className="visit_time_check_grp">
                                                            <RadioButton
                                                                inputId={time?.name}
                                                                name="selectedInspectionTime"
                                                                value={selectedInspectionTime}
                                                                onChange={(e: RadioButtonChangeEvent) => setSelectedInspectionTime(time)}
                                                                checked={selectedInspectionTime?.id === time?.id}
                                                            />
                                                            <label htmlFor={time?.name} className="ml-2">{time?.name}</label>
                                                        </div>
                                                        <div className="visit_time_grp">
                                                            <span>{formatTo12HourTime(time?.start_time)}&nbsp;-&nbsp;{formatTo12HourTime(time?.end_time)}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Alert modal */}
            <AlertModal
                isOpen={showAlertModal}
                onClose={() => setShowAlertModal(false)}
                message={alertMessage}
            />
            {/*  */}
        </React.Fragment>
    )
}

export default SiteVisit;